import { Feedback } from '../entity';
import { FeedbackId } from '../value';
import { FirestoreQueryBuilder } from '../../../../lib/gcp/builder/firestore-query.builder';
import { IRepository } from '../../../../utility/repository/repository';
import { Observable } from 'rxjs';

export abstract class IFeedbackRepository extends IRepository<FeedbackId, Feedback> {
  abstract selectAll(builder: FirestoreQueryBuilder<Feedback>): Observable<Feedback>;
}
